/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reset': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<circle pid="0" cx="15" cy="15" r="15" _fill="#fff"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M15 1C7.268 1 1 7.268 1 15s6.268 14 14 14 14-6.268 14-14S22.732 1 15 1zM0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z" _fill="#D0D3DA"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M10.63 9.43a.75.75 0 00-1.06 1.06L14.079 15l-4.51 4.509a.75.75 0 001.061 1.06l4.51-4.509 4.508 4.51a.75.75 0 101.061-1.061l-4.509-4.51 4.51-4.508a.75.75 0 10-1.062-1.061l-4.509 4.509-4.509-4.51z" _fill="#E42E16"/>'
  }
})
